import "@/App.css";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Bhootharaja from "@/pages/Bhootharaja";
import Lineage from "@/pages/Lineage";
import Deities from "@/pages/Deities";
import Branches from "@/pages/Branches";
import Institutions from "@/pages/Institutions";
import Publications from "@/pages/Publications";
import Sevas from "@/pages/Sevas";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import RoomBooking from "@/pages/RoomBooking";
import { EventsList, EventDetail } from "@/pages/Events";
import NotFound from "@/pages/NotFound";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <HashRouter>
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: {
              background: "#FBF7F0",
              border: "1px solid rgba(201, 162, 39, 0.4)",
              color: "#3B2A1A",
              fontFamily: "'Inter', sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/bhootharaja" element={<Bhootharaja />} />
          <Route path="/lineage" element={<Lineage />} />
          <Route path="/deities" element={<Deities />} />
          <Route path="/branches" element={<Branches />} />
          <Route path="/institutions" element={<Institutions />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/events" element={<EventsList />} />
          <Route path="/events/:slug" element={<EventDetail />} />
          <Route path="/sevas" element={<Sevas />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/rooms" element={<RoomBooking />} />
          {/* Legacy redirects */}
          <Route path="/history" element={<Navigate to="/about" replace />} />
          <Route path="/madhvacharya" element={<Navigate to="/lineage" replace />} />
          <Route path="/vadiraja" element={<Navigate to="/lineage?tab=vadiraja" replace />} />
          <Route path="/guru-parampara" element={<Navigate to="/lineage?tab=guru" replace />} />
          <Route path="/festivals" element={<Navigate to="/events" replace />} />
          <Route path="/news" element={<Navigate to="/events" replace />} />
          <Route path="/activities" element={<Navigate to="/events" replace />} />
          <Route path="/research" element={<Navigate to="/publications" replace />} />
          <Route path="/culture" element={<Navigate to="/events" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
